import { apiCall } from './_helper';

//--------------Account Details--------------------//

//Deletes a company account. Requires some very fancy settings to be viewable.
// Tested and working: 4/6/2025
export const deleteCompanySettings = async (companyId) => {
  return await apiCall({
    url: 'company/deleteCompany/' + companyId,
    method: 'DELETE',
    headers: {
      origin: window.origin,
    },
    notJSON: true,
  });
};

// Gets account details for a company
// Tested and working: 4/6/2025
export const getAccountDetails = async (companyId) => {
  return await apiCall({
    url: 'accountDetails/getDetails?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates account details for a company
// Tested and working: 4/6/2025
export const updateAccountDetailsApi = async (data) => {
  const formData = new FormData();
  formData.append('companyId', data.companyId);
  formData.append('companyName', data.companyName);
  formData.append('streetAddress', data.streetAddress);
  formData.append('townCity', data.townCity);
  formData.append('billable', data.billable ? 1 : 0);
  formData.append('countryId', data.countryId);
  formData.append('postCode', data.postCode);
  formData.append('logo', data.logo);
  formData.append('customerTypeId', data.customerTypeId);
  formData.append('euEori', data.euEori || '');
  formData.append('customerReference', data.customerReference || '');
  formData.append('notifications', data.notifications || '');

  return await apiCall({
    url: 'accountDetails/company',
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};
//--------------Terms and Condition Details--------------------//
export const getEnvelopeDetails = async (companyId) => {
  return await apiCall({
    url: `company/getEnvelopeDetails/${companyId}`,
    notJSON: true,
  });
};

export const revisitEnvelope = async (envelopeId, companyId) => {
  return await apiCall({
    url: `company/revisitEnvelope?envelopeId=${envelopeId}&companyId=${companyId}`,
    notJSON: true,
  });
};

//--------------User Details--------------------//

// Gets a list of users for a company for user maintenance
// Tested and working: 4/6/2025
export const getUserDetails = async (companyId) => {
  return await apiCall({
    url: 'users/getUser?companyId=' + companyId,
    notJSON: true,
  });
};

// Gets a list of roles for a company for user maintenance
// Tested and working: 4/6/2025
export const getUserRoles = async (companyId) => {
  return await apiCall({
    url: 'users/roles?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates user details for a company
// Tested and working: 4/6/2025
export const putUserDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('emailAddress', userData.userEmail);
  formData.append('roleId', userData.roleId);
  formData.append('firstname', userData.firstname || '');
  formData.append('lastname', userData.lastname || '');

  if (typeof userData.mfaEnable !== 'undefined') {
    formData.append('mfaEnable', userData.mfaEnable ?? true); // Default to true if not specified
  }

  return await apiCall({
    url: 'users/updateUser?companyId=' + companyId,
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};

// Creates a new user for a company
// Tested and working: 4/6/2025
export const postUserDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('emailAddress', userData.userEmail);
  formData.append('roleId', userData.roleId);
  formData.append('firstname', userData?.name?.split(' ')[0] || '');
  formData.append('lastname', userData?.name?.split(' ')[1] || '');

  if (typeof userData.mfaEnable !== 'undefined') {
    formData.append('mfaEnable', userData.mfaEnable ?? true); // Default to true if not specified
  }

  return await apiCall({
    url: 'users/createUser?companyId=' + companyId,
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

// Toggles the status of a user (enable/disable)
// Tested and working: 4/6/2025
export const disableUser = async (emailId) => {
  return await apiCall({
    url: 'users/toggleStatus?email=' + encodeURIComponent(emailId),
    notJSON: true,
  });
};

// Resends invite email for invited users
// Tested and working: 05/09/2025
export const resendUserInvite = async (companyId, emailAddress, firstname) => {
  const formData = new FormData();
  formData.append('emailAddress', emailAddress);
  formData.append('firstname', firstname);
  return await apiCall({
    url: `users/resendInvite?companyId=${companyId}`,
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

//--------------Trader Details--------------------//

// Gets a list of traders for a company for trader maintenance
// Tested and working: 4/6/2025
export const getTraderDetails = async (companyId) => {
  return await apiCall({
    url: 'traders/traderList?companyId=' + companyId,
    notJSON: true,
  });
};

// Updates trader details for a company
// Tested and working: 4/6/2025
export const putTraderDetails = async (userData, companyId) => {
  const formData = new FormData();
  formData.append('Id', userData.Id);
  formData.append('RefType', userData.RefType);
  formData.append('CompanyName', userData.CompanyName);
  formData.append('EORI', userData.EORI);
  formData.append('StreetAddress', userData.StreetAddress);
  formData.append('PostalCode', userData.PostalCode);
  formData.append('Country', userData.CountryCode);
  formData.append('City', userData.City);

  return await apiCall({
    url: 'traders/updateTrader?companyId=' + companyId,
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};

// Currently not in use. Functionality commented out in the UI
export const postTraderDetails = async (userData) => {
  return await apiCall({
    url: 'traders/',
    method: 'POST',
    body: JSON.stringify(userData),
  });
};

// Deletes a trader for a company
// Tested and working: 4/6/2025
export const deleteTrader = async (traderData, companyId) => {
  const formData = new FormData();
  formData.append('Id', traderData.id);
  formData.append('RefType', traderData.refType);

  return await apiCall({
    url: 'traders/deleteTrader?companyId=' + companyId,
    method: 'DELETE',
    body: formData,
    notJSON: true,
  });
};

// Restores a company
export const restoreCompany = async (companyId, companyName, companyEori) => {
  const formData = new FormData();
  formData.append('companyId', companyId);
  formData.append('company', companyName);
  formData.append('eori', companyEori);
  return await apiCall({
    url: 'accountDetails/restoreCompany',
    method: 'POST',
    body: formData,
    notJSON: true,
  });
};

export const updateGBEori = async (company, eoriNumber) => {
  return await apiCall({
    url: 'ens/updateGbEori',
    method: 'POST',
    body: JSON.stringify({
      companyId: company,
      eori: eoriNumber,
    }),
    onError: async (response) => {
      const errorData = await response.json();
      const err = new Error('Failed to update GB EORI Number');
      err.error = errorData.error;
      throw err;
    },
  });
};

// Maintenance banner — D2-CDS backend routes (visibility resolved server-side)
export const getMaintenanceBannerInfo = async () => {
  return await apiCall({
    url: 'maintenance-banner/info',
    notJSON: true,
    noAuth: !sessionStorage.getItem('token'),
  });
};

export const getMaintenanceBannerDetails = async () => {
  return await apiCall({
    url: 'maintenance-banner/details',
    notJSON: true,
  });
};

export const putMaintenanceBannerDetails = async (data) => {
  const formData = new FormData();
  formData.append('enabled', data.enabled ? 1 : 0);
  formData.append('bannerText', data.bannerText);
  formData.append('moreInfo', data.moreInfo || '');
  formData.append('startDate', data.startDate);
  formData.append('endDate', data.endDate);
  formData.append('visibility', data.visibility);

  return await apiCall({
    url: 'maintenance-banner/details',
    method: 'PUT',
    body: formData,
    notJSON: true,
  });
};
